import { SubscriptionTier, SubscriptionType } from "@WahooFitness/cloud-client-types";

// Matches on the productId portion alone (before the first ":"), since Android
// Play Billing base-plan subscriptions report plan codes as
// "productId:basePlanId" and the base plan id isn't guaranteed stable. Tier is
// a property of the product, so any base plan of it is the same tier.
// hasOwnProperty guard: plain `in`/bracket access would also match inherited Object.prototype keys.
function lookupTier(
  map: Partial<Record<string, SubscriptionTier>>,
  planCode: string | null | undefined
): SubscriptionTier | undefined {
  if (!planCode) return undefined;
  const baseProductId = planCode.split(":")[0];
  return Object.prototype.hasOwnProperty.call(map, baseProductId) ? map[baseProductId] : undefined;
}

// Known SYSTM plan codes from RevenueCat (Wahoo SYSTM / Wahoo SYSTM Staging apps).
// Keys are bare store product ids; lookupTier strips any ":basePlanId" suffix,
// so never add suffixed keys here. Mirrors SYSTM's SYSTM_IAP_PRODUCT_TIER_MAP;
// keep both in sync when a SKU changes.
export const SYSTM_PLAN_CODE_TIER_MAP: Partial<Record<string, SubscriptionTier>> = {
  // ios
  systm_app_ios_core_monthly: SubscriptionTier.Core, // prod core
  systm_ios_core_monthly: SubscriptionTier.Core, // stg core
  MONTHLY2020: SubscriptionTier.Pro, // prod pro
  MONTHLY2020STAGING: SubscriptionTier.Pro, // stg pro
  // android
  systm_android_core_monthly: SubscriptionTier.Core, // prod core
  systm_staging_android_core_monthly: SubscriptionTier.Core, // stg core
  monthly_plan: SubscriptionTier.Pro, // prod pro
  monthly_plan_staging: SubscriptionTier.Pro, // stg pro
};

export function isSystmSubscription(sub: SubscriptionType | null | undefined): boolean {
  return lookupTier(SYSTM_PLAN_CODE_TIER_MAP, sub?.plan_code) !== undefined;
}

export const PLAN_CODE_TIER_MAP: Partial<Record<string, SubscriptionTier>> = {
  // ios
  wahoo_app_ios_core_monthly: SubscriptionTier.Core, // prod and stg core
  WAHOO_MONTHLY_IOS: SubscriptionTier.Pro, // prod and stg pro
  // android
  wahoo_app_android_core_monthly: SubscriptionTier.Core, //prod and stg core
  wahoo_subscription: SubscriptionTier.Pro, // prod and stg pro
};

export function getTierForPlanCode(
  planCode: string | null | undefined
): SubscriptionTier | undefined {
  return lookupTier(PLAN_CODE_TIER_MAP, planCode);
}
